const constants = {
    ENV: {
        LOCAL_DEV: "local_dev",
        DEV: "development",
        QA: "qa",
        PRODUCTION: "production",
    },
    FOOTER_TEXT: {
        TERMS: "Terms of Use",
        PRIVACY: "Privacy Policy",
    },
    FileUploadAcceptTypes: ["doc", "docx", "xlsx", "pdf", "jpg", "jpeg"],
    PortalTypes: {
        Customer: "CUSTOMER",
        Dealer: "DEALER",
        Banker: "BANKER",
    },
    fieldGroups: [
        ["IsNew", "EquipmentType", "ConversionManufacturer", "Description"],
        ["Manufacturer", "Year", "Model", "SerialNums"],
        ["ListPrice", "EquipmentCost", "AssetSoftCost", "ConversionCost", "Quantity", "Odometer"],
    ],
    pricingFieldGroups: [
        ["FinanceProduct", "PricingOption", "Term", "DownPayment", "DealerMarkupRate", "DocFee", "SoftCost"],
        ["TradeInAllowance", "Rebate", "CashDown"],
        ["TitleAndRegistrationFee", "PermitFee", "Freight"]
    ],
    NorAppObjJSON: {
        Pricing: {
            sections: {
                "customer preferences": [
                    {
                        name: "Finance The Doc fees",
                        type: "checkbox",
                        fr_name: "Finances Les frais de Doc",
                        required: false,
                        hideField: false,
                        apiFieldName: "IsDocFeeFinanced",
                        defaultValue: true,
                        disabled: false,
                        commercial: {
                            disabled: true,
                            hideField: false,
                            defaultValue: false,
                        },
                    },
                    {
                        name: "Finance Soft Costs",
                        type: "checkbox",
                        fr_name: "Coûts accessoires du financement",
                        required: false,
                        hideField: false,
                        apiFieldName: "IsSoftCostFinanced",
                        defaultValue: true,
                        disabled: false,
                    },
                    {
                        name: "Finance One-Time Tax, If Applicable",
                        type: "checkbox",
                        fr_name: "Financer une taxe unique, le cas échéant",
                        required: false,
                        hideField: true,
                        apiFieldName: "IsOneTimeTaxFinanced",
                        defaultValue: true,
                        disabled: false,
                        commercial: {
                            disabled: true,
                            hideField: false,
                            defaultValue: false,
                        },
                    },
                ],
                Pricing: [
                    {
                        name: "Finance Product",
                        type: "dropdown",
                        fr_name: "Produit financier",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "FinanceProduct",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Pricing Options",
                        type: "dropdown",
                        fr_name: "Options de tarif",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "PricingOption",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Term Length In Months",
                        type: "dropdown",
                        fr_name: "Durée du mandat en mois",
                        required: true,
                        placeholder: "Months",
                        apiFieldName: "Term",
                        fr_placeholder: "Mois",
                        dropdownOptions: [],
                    },
                    {
                        name: "Down Payment",
                        type: "text",
                        fr_name: "Acompte",
                        required: true,
                        placeholder: "0",
                        apiFieldName: "DownPayment",
                        fr_placeholder: "0",
                    },
                    {
                        name: "Documentation Fee",
                        type: "text",
                        fr_name: "Frais de documentation",
                        required: false,
                        hideField: false,
                        placeholder: "$0.00",
                        apiFieldName: "DocFee",
                        fr_placeholder: "$0.00",
                    },
                    {
                        name: "Soft Costs",
                        type: "text",
                        fr_name: "Coûts accessoires",
                        required: false,
                        hideField: false,
                        placeholder: "$0.00",
                        apiFieldName: "SoftCost",
                        fr_placeholder: "$0.00",
                    },
                    {
                        name: "BuyDown Rate",
                        type: "dropdown",
                        fr_name: "Taux de rachat",
                        required: false,
                        placeholder: "",
                        apiFieldName: "DealerBuydownRate",
                        fr_placeholder: "",
                        dropdownOptions: [],
                    },
                ],
            },
        },
        "Files Upload": {},
        "Finance Options": {
            sections: {
                "Finance Options": [
                    {
                        name: "Finance Product",
                        type: "dropdown",
                        fr_name: "Produit financier",
                        required: true,
                        placeholder: "Finance Product",
                        apiFieldName: "FinanceProductId",
                        fr_placeholder: "Produit financier",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "label",
                    },
                    {
                        name: "Term Length in Months",
                        type: "dropdown",
                        fr_name: "Durée du mandat en mois",
                        required: true,
                        placeholder: "Months",
                        apiFieldName: "Term",
                        fr_placeholder: "Mois",
                        dropdownOptions: [],
                    },
                    {
                        name: "Down Payment",
                        type: "text",
                        fr_name: "Acompte",
                        required: true,
                        placeholder: "Down Payment",
                        apiFieldName: "DownPayment",
                        fr_placeholder: "Acompte",
                    },
                    {
                        name: "Total Asset Cost",
                        type: "text",
                        fr_name: "Coût total de l'actif",
                        required: false,
                        hideField: false,
                        isEditable: false,
                        placeholder: "Total Asset Cost",
                        apiFieldName: "TotalAssetCost",
                        fr_placeholder: "Coût total de l'actif",
                    },
                    {
                        name: "Total Amount Financed",
                        type: "text",
                        fr_name: "Montant total financé",
                        required: false,
                        hideField: false,
                        isEditable: false,
                        placeholder: "Total Amount Financed",
                        apiFieldName: "TotalAmountFinanced",
                        fr_placeholder: "Montant total financé",
                    },
                    {
                        name: "Is the asset being used for Rental purposes?",
                        type: "dropdown",
                        fr_name: "L'actif est-il utilisé à des fins de location ?",
                        required: true,
                        toolTipMsg: "",
                        placeholder: "Yes Or No",
                        apiFieldName: "IsRental",
                        fr_toolTipMsg: "",
                        fr_placeholder: "Oui ou non",
                        defaultValue: null,
                        IsNewRentalStatus: false,
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "Yes",
                            },
                            {
                                label: "No",
                                value: "No",
                            },
                        ],
                    },
                ],
            },
        },
        "Asset Information": {
            sections: {
                "Asset Information": [
                    {
                        name: "New Or Used",
                        type: "dropdown",
                        fr_name: "Neuf ou usagé",
                        required: true,
                        placeholder: "New Or Used",
                        apiFieldName: "IsNew",
                        fr_placeholder: "Neuf ou usagé",
                        dropdownOptions: [
                            {
                                label: "New",
                                value: "New",
                            },
                            {
                                label: "Used",
                                value: "Used",
                            },
                        ],
                    },
                    {
                        name: "Equipment Type",
                        type: "dropdown",
                        fr_name: "Type d'équipement",
                        required: true,
                        placeholder: "Equipment Type",
                        apiFieldName: "EquipmentType",
                        fr_placeholder: "Type d'équipement",
                        dropdownOptions: [],
                    },
                    {
                        name: "Equipment Description",
                        type: "text",
                        fr_name: "Description de l'équipement",
                        required: true,
                        placeholder: "Equipment Description",
                        apiFieldName: "Description",
                        fr_placeholder: "Description de l'équipement",
                    },
                    {
                        name: "Equipment Manufacturer",
                        type: "dropdown",
                        fr_name: "Fabricant d'équipement",
                        required: true,
                        placeholder: "Equipment Manufacturer",
                        apiFieldName: "Manufacturer",
                        fr_placeholder: "Fabricant d'équipement",
                        dropdownOptions: [],
                    },
                    {
                        name: "Model",
                        type: "dropdown",
                        fr_name: "Modèle",
                        required: false,
                        hideField: false,
                        placeholder: "Model",
                        apiFieldName: "Model",
                        fr_placeholder: "Modèle",
                        dropdownOptions: [],
                    },
                    {
                        name: "Year",
                        type: "text",
                        fr_name: "Année",
                        required: true,
                        placeholder: "Year",
                        apiFieldName: "Year",
                        fr_placeholder: "Année",
                    },
                    {
                        name: "SN/VIN#",
                        type: "text",
                        fr_name: "Numéro SN/VIN",
                        required: false,
                        hideField: false,
                        toolTipMsg: "Please note this is an optional field. However, multiple SN / VIN # can be added for your assets, separated by commas, with a count matching the asset quantity. (e.g. SN12345,SN67890,VIN234567 for 3 assets)",
                        placeholder: "SN/VIN#",
                        apiFieldName: "SerialNums",
                        fr_toolTipMsg: "Veuillez noter qu'il s'agit d'un champ facultatif. Cependant, plusieurs numéros SN/VIN peuvent être ajoutés pour vos actifs, séparés par des virgules, avec un nombre correspondant à la quantité d'actifs. (par exemple SN12345,SN67890,VIN234567 pour 3 actifs)",
                        fr_placeholder: "Numéro SN/VIN",
                    },
                    {
                        name: "Is this a Titled Asset?",
                        type: "checkbox",
                        fr_name: "Est-ce un bien titré ?",
                        required: false,
                        hideField: false,
                        defaultValue: null,
                        apiFieldName: "IsTitledAsset",
                        followUpField: {
                            name: "Will the dealer complete the titling process?",
                            fr_name: "Le concessionnaire complétera-t-il le processus de titrage ?",
                            required: true,
                            hideField: false,
                            apiFieldName: "DealerCompletingTitling",
                        },
                    },
                    {
                        name: "MSRP",
                        type: "text",
                        fr_name: "Prix ​​de détail suggéré",
                        required: false,
                        placeholder: "MSRP",
                        apiFieldName: "ListPrice",
                        fr_placeholder: "Prix ​​de détail suggéré",
                        toolTipMsg: "Manufacturer's Suggested Retail Price",
                        fr_toolTipMsg: "Prix ​​de détail suggéré par le fabricant",
                    },
                    {
                        name: "Equipment Cost (Per Unit)",
                        type: "text",
                        fr_name: "Coût de l'équipement (par unité)",
                        required: true,
                        placeholder: "Cost",
                        apiFieldName: "EquipmentCost",
                        fr_placeholder: "Coût",
                    },
                    {
                        name: "Soft Cost",
                        type: "text",
                        fr_name: "Coûts accessoires",
                        required: false,
                        hideField: true,
                        toolTipMsg: "Soft costs (charges such as warranties, extra tyres/tracks, PDI, assembly charges, or destination charges) associated with this asset. These are separate from the asset price and are included in the financed amount. Defaults to $0.00 if not provided.",
                        fr_toolTipMsg: "Coûts accessoires (frais tels que garanties, pneus/chenilles supplémentaires, PDI, frais d'assemblage ou frais de destination) associés à cet actif. Ces coûts sont distincts du prix de l'actif et sont inclus dans le montant financé. La valeur par défaut est de 0,00 $ si aucune valeur n'est fournie.",
                        placeholder: "Soft Cost",
                        apiFieldName: "AssetSoftCost",
                        fr_placeholder: "Coûts accessoires",
                    },
                    {
                        name: "Quantity",
                        type: "text",
                        fr_name: "Quantité",
                        required: true,
                        placeholder: "Quantity",
                        apiFieldName: "Quantity",
                        fr_placeholder: "Quantité",
                    },
                ],
            },
        },
        "Document Signer Information": {
            sections: {
                "Primary Contact": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Cell Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                    {
                        name: "Business Association",
                        type: "dropdown",
                        fr_name: "Association d'entreprises",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "CustomerIndex",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Title",
                        type: "dropdown",
                        fr_name: "Titre",
                        required: false,
                        placeholder: "Title",
                        apiFieldName: "Title",
                        fr_placeholder: "Titre",
                        dropdownOptions: [],
                    },
                    {
                        name: "Doc Signer",
                        type: "dropdown",
                        fr_name: "Signateur de document",
                        required: true,
                        toolTipMsg: "This is the person who is going to sign the documents",
                        placeholder: "Doc Signer",
                        apiFieldName: "DocSigner",
                        fr_toolTipMsg: "C'est la personne qui va signer les documents",
                        fr_placeholder: "Signateur de document",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "Yes",
                            },
                            {
                                label: "No",
                                value: "No",
                            },
                        ],
                    },
                ],
            },
        },
        "Customer Information": {
            sections: {
                "Address Details": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    }
                ],
                "Billing Address": [
                    {
                        name: "Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "BillingAddress",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "BillingCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "BillingState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "BillingCity",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "BillingPostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "Enter multiple email addresses separated by a semicolon and space (e.g., customer1@example.com; customer2@example.com)",
                        fr_toolTipMsg: "Saisissez plusieurs adresses e-mail séparées par un point-virgule et un espace (par exemple, client1@exemple.com ; client2@exemple.com)",
                        placeholder: "Email",
                        apiFieldName: "BillingEmail",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "BillingPhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Entity Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Entity Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Legal Registered Name",
                        type: "text",
                        fr_name: "Nom légal enregistré",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Legal Registered Name",
                        apiFieldName: "LegalRegName",
                        fr_placeholder: "Nom légal enregistré",
                    },
                    {
                        name: "DBA Name",
                        type: "text",
                        fr_name: "Nom DBA",
                        required: false,
                        hideField: false,
                        maxLength: 100,
                        toolTipMsg: "”Doing Business As” or Tradename",
                        placeholder: "DBA Name",
                        apiFieldName: "DBAName",
                        fr_toolTipMsg: "« Faire affaire sous le nom » ou nom commercial",
                        fr_placeholder: "Nom DBA",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        maxLength: 15,
                        toolTipMsg: "Federal Tax ID (US)/Business Number (Canada)",
                        placeholder: "FED TAX ID/BN#",
                        apiFieldName: "SSN",
                        fr_toolTipMsg: "Numéro d'identification fiscale fédérale (États-Unis)/numéro d'entreprise (Canada)",
                        fr_placeholder: "Numéro d'identification fiscale/BN de la FED",
                        dropdownOptions: [],
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "CustCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "CustState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "Date Business Incorporated",
                        type: "date",
                        fr_name: "Date de constitution de l'entreprise",
                        required: false,
                        hideField: false,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "MM/DD/YYYY",
                        apiFieldName: "BusinessIncorporatedDate",
                        fr_placeholder: "MM/DD/YYYY",
                        dropdownOptions: [],
                    },
                    {
                        name: "Gross Annual Revenue",
                        type: "text",
                        fr_name: "Chiffre d'affaires annuel brut",
                        hideField: true,
                        required: false,
                        placeholder: "Gross Annual Revenue",
                        apiFieldName: "GrossRevenue",
                        fr_placeholder: "Chiffre d'affaires annuel brut",
                    },
                    {
                        name: "Tax Exempt",
                        type: "dropdown",
                        fr_name: "Exempt d'impôt",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "",
                        apiFieldName: "TaxExempt",
                        fr_placeholder: "",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "true",
                            },
                            {
                                label: "No",
                                value: "false",
                            },
                        ],
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    }
                ],
            },
        },
        "Guarantor Information": {
            sections: {
                "Home Address": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip / code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Code Postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Business Name",
                        type: "text",
                        fr_name: "Nom de l'entreprise",
                        required: true,
                        placeholder: "Business Name",
                        apiFieldName: "BusinessName",
                        fr_placeholder: "Nom de l'entreprise",
                    },
                    {
                        name: "Company Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Company Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        placeholder: "Tax ID",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro d'identification fiscale",
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    },
                ],
            },
        },
    },
    LocAppObjJSON: {
        "Files Upload": {},
        "Document Signer Information": {
            sections: {
                "Primary Contact": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Cell Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                    {
                        name: "Business Association",
                        type: "dropdown",
                        fr_name: "Association d'entreprises",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "CustomerIndex",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Title",
                        type: "dropdown",
                        fr_name: "Titre",
                        required: false,
                        placeholder: "Title",
                        apiFieldName: "Title",
                        fr_placeholder: "Titre",
                        dropdownOptions: [],
                    },
                    {
                        name: "Doc Signer",
                        type: "dropdown",
                        fr_name: "Signateur de document",
                        required: true,
                        toolTipMsg: "This is the person who is going to sign the documents",
                        placeholder: "Doc Signer",
                        apiFieldName: "DocSigner",
                        fr_toolTipMsg: "C'est la personne qui va signer les documents",
                        fr_placeholder: "Signateur de document",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "Yes",
                            },
                            {
                                label: "No",
                                value: "No",
                            },
                        ],
                    },
                ],
            },
        },
        "Customer Information": {
            sections: {
                "Address Details": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    },
                ],
                "Billing Address": [
                    {
                        name: "Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "BillingAddress",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "BillingCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "BillingState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "BillingCity",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "BillingPostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "Enter multiple email addresses separated by a semicolon and space (e.g., customer1@example.com; customer2@example.com)",
                        fr_toolTipMsg: "Saisissez plusieurs adresses e-mail séparées par un point-virgule et un espace (par exemple, client1@exemple.com ; client2@exemple.com)",
                        placeholder: "Email",
                        apiFieldName: "BillingEmail",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "BillingPhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Legal Registered Name",
                        type: "text",
                        fr_name: "Nom légal enregistré",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Legal Registered Name",
                        apiFieldName: "LegalRegName",
                        fr_placeholder: "Nom légal enregistré",
                    },
                    {
                        name: "DBA Name",
                        type: "text",
                        fr_name: "Nom DBA",
                        required: false,
                        hideField: false,
                        maxLength: 100,
                        toolTipMsg: "”Doing Business As” or Tradename",
                        placeholder: "DBA Name",
                        apiFieldName: "DBAName",
                        fr_toolTipMsg: "« Faire affaire sous le nom » ou nom commercial",
                        fr_placeholder: "Nom DBA",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        maxLength: 15,
                        toolTipMsg: "Federal Tax ID (US)/Business Number (Canada)",
                        placeholder: "FED TAX ID/BN#",
                        apiFieldName: "SSN",
                        fr_toolTipMsg: "Numéro d'identification fiscale fédérale (États-Unis)/numéro d'entreprise (Canada)",
                        fr_placeholder: "Numéro d'identification fiscale/BN de la FED",
                        dropdownOptions: [],
                    },
                    {
                        name: "Entity Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Entity Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "CustCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "CustState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "Date Business Incorporated",
                        type: "date",
                        fr_name: "Date de constitution de l'entreprise",
                        required: false,
                        hideField: false,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "MM/DD/YYYY",
                        apiFieldName: "BusinessIncorporatedDate",
                        fr_placeholder: "MM/DD/YYYY",
                        dropdownOptions: [],
                    },
                    {
                        name: "Gross Annual Revenue",
                        type: "text",
                        fr_name: "Chiffre d'affaires annuel brut",
                        hideField: false,
                        required: true,
                        placeholder: "Gross Annual Revenue",
                        apiFieldName: "GrossRevenue",
                        fr_placeholder: "Chiffre d'affaires annuel brut",
                    },
                    {
                        name: "Tax Exempt",
                        type: "dropdown",
                        fr_name: "Exempt d'impôt",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "",
                        apiFieldName: "TaxExempt",
                        fr_placeholder: "",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "true",
                            },
                            {
                                label: "No",
                                value: "false",
                            },
                        ],
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    },
                ],
            },
        },
        "Guarantor Information": {
            sections: {
                "Home Address": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip / code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Code Postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Business Name",
                        type: "text",
                        fr_name: "Nom de l'entreprise",
                        required: true,
                        placeholder: "Business Name",
                        apiFieldName: "BusinessName",
                        fr_placeholder: "Nom de l'entreprise",
                    },
                    {
                        name: "Company Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Company Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        placeholder: "Tax ID",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro d'identification fiscale",
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_palceholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    },
                ],
            },
        },
        "Line of Credit Request": {
            sections: {
                "Line of Credit Request": [
                    {
                        name: "Finance Product",
                        type: "dropdown",
                        fr_name: "Produit financier",
                        required: true,
                        placeholder: "Finance Product",
                        apiFieldName: "FinanceProductId",
                        fr_placeholder: "Produit financier",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "label",
                    },
                    {
                        name: "Amount Requested",
                        type: "text",
                        fr_name: "Montant demandé",
                        required: true,
                        placeholder: "$0.00",
                        apiFieldName: "AmountRequested",
                        fr_placeholder: "$0.00",
                        dropdownOptions: [],
                    },
                    {
                        name: "Purpose of Finance",
                        type: "text",
                        fr_name: "Objectif du financement",
                        required: true,
                        placeholder: "Enter Text",
                        apiFieldName: "PurposeOfFinance",
                        fr_placeholder: "Entrez du texte",
                        dropdownOptions: [],
                    },
                ],
            },
        },
    },
    SchAppObjJSON: {
        Pricing: {
            sections: {
                "customer preferences": [
                    {
                        name: "Finance The Doc fees",
                        type: "checkbox",
                        fr_name: "Finances Les frais de Doc",
                        required: false,
                        hideField: false,
                        defaultValue: true,
                        disabled: false,
                        apiFieldName: "IsDocFeeFinanced",
                        commercial: {
                            disabled: true,
                            hideField: false,
                            defaultValue: false,
                        },
                    },
                    {
                        name: "Finance Soft Costs",
                        type: "checkbox",
                        fr_name: "Coûts accessoires du financement",
                        required: false,
                        hideField: false,
                        defaultValue: true,
                        disabled: false,
                        apiFieldName: "IsSoftCostFinanced",
                    },
                    {
                        name: "Finance One-Time Tax, If Applicable",
                        type: "checkbox",
                        fr_name: "Financer une taxe unique, le cas échéant",
                        required: false,
                        hideField: true,
                        defaultValue: true,
                        disabled: false,
                        apiFieldName: "IsOneTimeTaxFinanced",
                        commercial: {
                            disabled: true,
                            hideField: false,
                            defaultValue: false,
                        },
                    },
                ],
                Pricing: [
                    {
                        name: "Finance Product",
                        type: "dropdown",
                        fr_name: "Produit financier",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "FinanceProduct",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Pricing Options",
                        type: "dropdown",
                        fr_name: "Options de tarif",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "PricingOption",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Term Length In Months",
                        type: "dropdown",
                        fr_name: "Durée du mandat en mois",
                        required: true,
                        placeholder: "Months",
                        apiFieldName: "Term",
                        fr_placeholder: "Mois",
                        dropdownOptions: [],
                    },
                    {
                        name: "Down Payment",
                        type: "text",
                        fr_name: "Acompte",
                        required: true,
                        placeholder: "0",
                        apiFieldName: "DownPayment",
                        fr_placeholder: "0",
                    },
                    {
                        name: "Documentation Fee",
                        type: "text",
                        fr_name: "Frais de documentation",
                        required: false,
                        hideField: false,
                        placeholder: "$0.00",
                        apiFieldName: "DocFee",
                        fr_placeholder: "$0.00",
                    },
                    {
                        name: "Soft Costs",
                        type: "text",
                        fr_name: "Coûts accessoires",
                        required: false,
                        hideField: false,
                        placeholder: "$0.00",
                        apiFieldName: "SoftCost",
                        fr_placeholder: "$0.00",
                    },
                    {
                        name: "BuyDown Rate",
                        type: "dropdown",
                        fr_name: "Taux de rachat",
                        required: false,
                        placeholder: "",
                        apiFieldName: "DealerBuydownRate",
                        fr_placeholder: "",
                        dropdownOptions: [],
                    },
                ],
            },
        },
        "Files Upload": {},
        "Finance Options": {
            sections: {
                "Finance Options": [
                    {
                        name: "Finance Product",
                        type: "dropdown",
                        fr_name: "Produit financier",
                        required: true,
                        placeholder: "Finance Product",
                        apiFieldName: "FinanceProductId",
                        fr_placeholder: "Produit financier",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "label",
                    },
                    {
                        name: "Term Length in Months",
                        type: "dropdown",
                        fr_name: "Durée du mandat en mois",
                        required: true,
                        placeholder: "Months",
                        apiFieldName: "Term",
                        fr_placeholder: "Mois",
                        dropdownOptions: [],
                    },
                    {
                        name: "Down Payment",
                        type: "text",
                        fr_name: "Acompte",
                        required: true,
                        placeholder: "Down Payment",
                        apiFieldName: "DownPayment",
                        fr_placeholder: "Acompte",
                    },
                    {
                        name: "Total Asset Cost",
                        type: "text",
                        fr_name: "Coût total de l'actif",
                        required: false,
                        hideField: false,
                        isEditable: false,
                        placeholder: "Total Asset Cost",
                        apiFieldName: "TotalAssetCost",
                        fr_placeholder: "Coût total de l'actif",
                    },
                    {
                        name: "Total Amount Financed",
                        type: "text",
                        fr_name: "Montant total financé",
                        required: false,
                        hideField: false,
                        isEditable: false,
                        placeholder: "Total Amount Financed",
                        apiFieldName: "TotalAmountFinanced",
                        fr_placeholder: "Montant total financé",
                    },
                    {
                        name: "Is the asset being used for Rental purposes?",
                        type: "dropdown",
                        fr_name: "L'actif est-il utilisé à des fins de location ?",
                        required: true,
                        toolTipMsg: "",
                        placeholder: "Yes Or No",
                        apiFieldName: "IsRental",
                        fr_toolTipMsg: "",
                        fr_placeholder: "Oui ou non",
                        defaultValue: null,
                        IsNewRentalStatus: false,
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "Yes",
                            },
                            {
                                label: "No",
                                value: "No",
                            },
                        ],
                    },
                ],
            },
        },
        "Asset Information": {
            sections: {
                "Asset Information": [
                    {
                        name: "New Or Used",
                        type: "dropdown",
                        fr_name: "Neuf ou usagé",
                        required: true,
                        placeholder: "New Or Used",
                        apiFieldName: "IsNew",
                        fr_placeholder: "Neuf ou usagé",
                        dropdownOptions: [
                            {
                                label: "New",
                                value: "New",
                            },
                            {
                                label: "Used",
                                value: "Used",
                            },
                        ],
                    },
                    {
                        name: "Equipment Type",
                        type: "dropdown",
                        fr_name: "Type d'équipement",
                        required: true,
                        placeholder: "Equipment Type",
                        apiFieldName: "EquipmentType",
                        fr_placeholder: "Type d'équipement",
                        dropdownOptions: [],
                    },
                    {
                        name: "Equipment Description",
                        type: "text",
                        fr_name: "Description de l'équipement",
                        required: true,
                        placeholder: "Equipment Description",
                        apiFieldName: "Description",
                        fr_placeholder: "Description de l'équipement",
                    },
                    {
                        name: "Equipment Manufacturer",
                        type: "dropdown",
                        fr_name: "Fabricant d'équipement",
                        required: true,
                        placeholder: "Equipment Manufacturer",
                        apiFieldName: "Manufacturer",
                        fr_placeholder: "Fabricant d'équipement",
                        dropdownOptions: [],
                    },
                    {
                        name: "Model",
                        type: "dropdown",
                        fr_name: "Modèle",
                        required: false,
                        hideField: false,
                        placeholder: "Model",
                        apiFieldName: "Model",
                        fr_placeholder: "Modèle",
                        dropdownOptions: [],
                    },
                    {
                        name: "Year",
                        type: "text",
                        fr_name: "Année",
                        required: true,
                        placeholder: "Year",
                        apiFieldName: "Year",
                        fr_placeholder: "Année",
                    },
                    {
                        name: "SN/VIN#",
                        type: "text",
                        fr_name: "Numéro SN/VIN",
                        required: false,
                        hideField: false,
                        toolTipMsg: "Please note this is an optional field. However, multiple SN / VIN # can be added for your assets, separated by commas, with a count matching the asset quantity. (e.g. SN12345,SN67890,VIN234567 for 3 assets)",
                        placeholder: "SN/VIN#",
                        apiFieldName: "SerialNums",
                        fr_toolTipMsg: "Veuillez noter qu'il s'agit d'un champ facultatif. Cependant, plusieurs numéros SN/VIN peuvent être ajoutés pour vos actifs, séparés par des virgules, avec un nombre correspondant à la quantité d'actifs. (par exemple SN12345,SN67890,VIN234567 pour 3 actifs)",
                        fr_placeholder: "Numéro SN/VIN",
                    },
                    {
                        name: "Is this a Titled Asset?",
                        type: "checkbox",
                        fr_name: "Est-ce un bien titré ?",
                        required: false,
                        hideField: false,
                        defaultValue: null,
                        apiFieldName: "IsTitledAsset",
                        followUpField: {
                            name: "Will the dealer complete the titling process?",
                            fr_name: "Le concessionnaire complétera-t-il le processus de titrage ?",
                            required: true,
                            hideField: false,
                            apiFieldName: "DealerCompletingTitling",
                        },
                    },
                    {
                        name: "MSRP",
                        type: "text",
                        fr_name: "Prix ​​de détail suggéré",
                        required: false,
                        placeholder: "MSRP",
                        apiFieldName: "ListPrice",
                        fr_placeholder: "Prix ​​de détail suggéré",
                        toolTipMsg: "The Manufacturer's Suggested Retail Price (MSRP) is the price at which the manufacturer recommends that the retailer sell the product. It serves as a guideline for pricing and is often used as a benchmark for discounts and promotions.",
                        fr_toolTipMsg: "Le prix de détail suggéré par le fabricant (PDSF) est le prix auquel le fabricant recommande que le détaillant vende le produit. Il sert de guide pour la tarification et est souvent utilisé comme référence pour les rabais et les promotions.",
                    },
                    {
                        name: "Equipment Cost (Per Unit)",
                        type: "text",
                        fr_name: "Coût de l'équipement (par unité)",
                        required: true,
                        placeholder: "Cost",
                        apiFieldName: "EquipmentCost",
                        fr_placeholder: "Coût",
                    },
                    {
                        name: "Soft Cost",
                        type: "text",
                        fr_name: "Coûts accessoires",
                        required: false,
                        hideField: true,
                        toolTipMsg: "Soft costs (charges such as warranties, extra tyres/tracks, PDI, assembly charges, or destination charges) associated with this asset. These are separate from the asset price and are included in the financed amount. Defaults to $0.00 if not provided.",
                        fr_toolTipMsg: "Coûts accessoires (frais tels que garanties, pneus/chenilles supplémentaires, PDI, frais d'assemblage ou frais de destination) associés à cet actif. Ces coûts sont distincts du prix de l'actif et sont inclus dans le montant financé. La valeur par défaut est de 0,00 $ si aucune valeur n'est fournie.",
                        placeholder: "Soft Cost",
                        apiFieldName: "AssetSoftCost",
                        fr_placeholder: "Coûts accessoires",
                    },
                    {
                        name: "Quantity",
                        type: "text",
                        fr_name: "Quantité",
                        required: true,
                        placeholder: "Quantity",
                        apiFieldName: "Quantity",
                        fr_placeholder: "Quantité",
                    },
                ],
            },
        },
        "Document Signer Information": {
            sections: {
                "Primary Contact": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Cell Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                    {
                        name: "Business Association",
                        type: "dropdown",
                        fr_name: "Association d'entreprises",
                        required: true,
                        placeholder: "Select",
                        apiFieldName: "CustomerIndex",
                        fr_placeholder: "Sélectionner",
                        dropdownOptions: [],
                    },
                    {
                        name: "Title",
                        type: "dropdown",
                        fr_name: "Titre",
                        required: false,
                        placeholder: "Title",
                        apiFieldName: "Title",
                        fr_placeholder: "Titre",
                        dropdownOptions: [],
                    },
                    {
                        name: "Doc Signer",
                        type: "dropdown",
                        fr_name: "Signateur de document",
                        required: true,
                        toolTipMsg: "This is the person who is going to sign the documents",
                        placeholder: "Doc Signer",
                        apiFieldName: "DocSigner",
                        fr_toolTipMsg: "C'est la personne qui va signer les documents",
                        fr_placeholder: "Signateur de document",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "Yes",
                            },
                            {
                                label: "No",
                                value: "No",
                            },
                        ],
                    },
                ],
            },
        },
        "Customer Information": {
            sections: {
                "Address Details": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    },
                ],
                "Billing Address": [
                    {
                        name: "Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "BillingAddress",
                        fr_placeholder: "Adresse principale",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "BillingCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "BillingState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "BillingCity",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip/Code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "BillingPostalCode",
                        fr_placeholder: "Zip/Code postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "Enter multiple email addresses separated by a semicolon and space (e.g., customer1@example.com; customer2@example.com)",
                        fr_toolTipMsg: "Saisissez plusieurs adresses e-mail séparées par un point-virgule et un espace (par exemple, client1@exemple.com ; client2@exemple.com)",
                        placeholder: "Email",
                        apiFieldName: "BillingEmail",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "BillingPhoneNumber",
                        fr_placeholder: "Numéro de téléphone",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Legal Registered Name",
                        type: "text",
                        fr_name: "Nom légal enregistré",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Legal Registered Name",
                        apiFieldName: "LegalRegName",
                        fr_placeholder: "Nom légal enregistré",
                    },
                    {
                        name: "DBA Name",
                        type: "text",
                        fr_name: "Nom DBA",
                        required: false,
                        hideField: false,
                        maxLength: 100,
                        toolTipMsg: "”Doing Business As” or Tradename",
                        placeholder: "DBA Name",
                        apiFieldName: "DBAName",
                        fr_toolTipMsg: "« Faire affaire sous le nom » ou nom commercial",
                        fr_placeholder: "Nom DBA",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        maxLength: 15,
                        toolTipMsg: "Federal Tax ID (US)/Business Number (Canada)",
                        placeholder: "FED TAX ID/BN#",
                        apiFieldName: "SSN",
                        fr_toolTipMsg: "Numéro d'identification fiscale fédérale (États-Unis)/numéro d'entreprise (Canada)",
                        fr_placeholder: "Numéro d'identification fiscale/BN de la FED",
                        dropdownOptions: [],
                    },
                    {
                        name: "Entity Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Entity Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "CustCountry",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province de constitution",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "CustState",
                        fr_placeholder: "État/Province",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "Date Business Incorporated",
                        type: "date",
                        fr_name: "Date de constitution de l'entreprise",
                        required: false,
                        hideField: false,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "MM/DD/YYYY",
                        apiFieldName: "BusinessIncorporatedDate",
                        fr_placeholder: "MM/DD/YYYY",
                        dropdownOptions: [],
                    },
                    {
                        name: "Gross Annual Revenue",
                        type: "text",
                        fr_name: "Chiffre d'affaires annuel brut",
                        hideField: true,
                        required: false,
                        placeholder: "Gross Annual Revenue",
                        apiFieldName: "GrossRevenue",
                        fr_placeholder: "Chiffre d'affaires annuel brut",
                    },
                    {
                        name: "Tax Exempt",
                        type: "dropdown",
                        fr_name: "Exempt d'impôt",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "",
                        apiFieldName: "TaxExempt",
                        fr_placeholder: "",
                        dropdownOptions: [
                            {
                                label: "Yes",
                                value: "true",
                            },
                            {
                                label: "No",
                                value: "false",
                            },
                        ],
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    },
                ],
            },
        },
        "Guarantor Information": {
            sections: {
                "Home Address": [
                    {
                        name: "Main Address",
                        type: "text",
                        fr_name: "Adresse principale",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "Address",
                        apiFieldName: "Address",
                        fr_placeholder: "Adresse",
                    },
                    {
                        name: "Country",
                        type: "dropdown",
                        fr_name: "Pays",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Country",
                        apiFieldName: "Country",
                        fr_placeholder: "Pays",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "country",
                    },
                    {
                        name: "State/Province Of Incorporation",
                        type: "dropdown",
                        fr_name: "État/Province",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "State",
                        apiFieldName: "State",
                        fr_placeholder: "État",
                        dropdownOptions: [],
                        dropdownOptionValueKey: "code",
                        dropdownOptionDisplayKey: "state",
                    },
                    {
                        name: "City",
                        type: "text",
                        fr_name: "Ville",
                        required: true,
                        maxLength: 100,
                        toolTipMsg: "",
                        placeholder: "City",
                        apiFieldName: "City",
                        fr_placeholder: "Ville",
                    },
                    {
                        name: "Zip/Postal Code",
                        type: "text",
                        fr_name: "Zip / code postal",
                        required: true,
                        maxLength: 9,
                        toolTipMsg: "",
                        placeholder: "Zip/Postal Code",
                        apiFieldName: "PostalCode",
                        fr_placeholder: "Code Postal",
                    },
                    {
                        name: "Email",
                        type: "text",
                        fr_name: "E-mail",
                        required: true,
                        maxLength: 60,
                        toolTipMsg: "",
                        placeholder: "Email",
                        apiFieldName: "Email",
                        fr_placeholder: "E-mail",
                    },
                    {
                        name: "Phone Number",
                        type: "text",
                        fr_name: "Numéro de téléphone portable",
                        required: true,
                        maxLength: 10,
                        toolTipMsg: "",
                        placeholder: "Phone Number",
                        apiFieldName: "PhoneNumber",
                        fr_placeholder: "Numéro de téléphone portable",
                        startAdornment: "+1",
                    },
                ],
                "Business Details": [
                    {
                        name: "Business Name",
                        type: "text",
                        fr_name: "Nom de l'entreprise",
                        required: true,
                        placeholder: "Business Name",
                        apiFieldName: "BusinessName",
                        fr_placeholder: "Nom de l'entreprise",
                    },
                    {
                        name: "Company Type",
                        type: "dropdown",
                        fr_name: "Type d'entité",
                        required: true,
                        maxLength: null,
                        toolTipMsg: "",
                        placeholder: "Company Type",
                        apiFieldName: "CompanyCode",
                        fr_placeholder: "Type d'entité",
                        dropdownOptions: [
                            {
                                id: "1",
                                Code: "C",
                                Description: "Corporation",
                            },
                            {
                                id: "14",
                                Code: "SC",
                                Description: "S Corp",
                            },
                            {
                                id: "3",
                                Code: "G",
                                Description: "Federal Government",
                            },
                            {
                                id: "5",
                                Code: "LLC",
                                Description: "Limited Liability Company",
                            },
                            {
                                id: "6",
                                Code: "LLP",
                                Description: "Limited Liability Partnership",
                            },
                            {
                                id: "7",
                                Code: "N",
                                Description: "Non Profit",
                            },
                            {
                                id: "8",
                                Code: "O",
                                Description: "Other",
                            },
                            {
                                id: "9",
                                Code: "P",
                                Description: "Partnership",
                            },
                            {
                                id: "10",
                                Code: "R",
                                Description: "Sole Proprietorship",
                            },
                            {
                                id: "13",
                                Code: "TRUST",
                                Description: "Trust or Estate",
                            },
                            {
                                id: "17",
                                Code: "M",
                                Description: "Municipal",
                            },
                        ],
                        dropdownOptionValueKey: "Code",
                        dropdownOptionDisplayKey: "Description",
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "FED TAX ID/BN#",
                        type: "text",
                        fr_name: "Numéro d'identification fiscale/BN de la FED",
                        required: true,
                        placeholder: "Tax ID",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro d'identification fiscale",
                    },
                ],
                "Individual Details": [
                    {
                        name: "First Name",
                        type: "text",
                        fr_name: "Prénom",
                        required: true,
                        placeholder: "First Name",
                        apiFieldName: "FirstName",
                        fr_placeholder: "Prénom",
                    },
                    {
                        name: "Middle Name",
                        type: "text",
                        fr_name: "Deuxième prénom",
                        required: false,
                        hideField: false,
                        placeholder: "Middle Name",
                        apiFieldName: "MiddleName",
                        fr_placeholder: "Deuxième prénom",
                    },
                    {
                        name: "Last Name",
                        type: "text",
                        fr_name: "Nom de famille",
                        required: true,
                        placeholder: "Last Name",
                        apiFieldName: "LastName",
                        fr_placeholder: "Nom de famille",
                    },
                    {
                        name: "Suffix",
                        type: "dropdown",
                        fr_name: "Suffixe",
                        required: false,
                        placeholder: "Suffix",
                        apiFieldName: "Suffix",
                        fr_placeholder: "Suffixe",
                        dropdownOptions: [
                            {
                                label: "I",
                                value: "I",
                            },
                            {
                                label: "II",
                                value: "II",
                            },
                            {
                                label: "III",
                                value: "III",
                            },
                            {
                                label: "IV",
                                value: "IV",
                            },
                            {
                                label: "V",
                                value: "V",
                            },
                            {
                                label: "Sr.",
                                value: "Sr.",
                            },
                            {
                                label: "Jr.",
                                value: "Jr.",
                            },
                        ],
                    },
                    {
                        name: "Percent Ownership%",
                        type: "text",
                        fr_name: "pourcentage de propriété%",
                        required: true,
                        placeholder: "Percent Ownership",
                        apiFieldName: "OwnershipPercentage",
                        fr_placeholder: "Pourcentage de propriété",
                    },
                    {
                        name: "Business Title",
                        type: "text",
                        fr_name: "Titre Professionnel",
                        required: false,
                        hideField: false,
                        placeholder: "Business Title",
                        apiFieldName: "BusinessTitle",
                        fr_placeholder: "Titre Professionnel",
                    },
                    {
                        name: "SSN#/TIN#/SIN#",
                        type: "text",
                        fr_name: "Numéro SSN/TIN#/SIN#",
                        required: true,
                        placeholder: "SSN Number",
                        apiFieldName: "SSN",
                        fr_placeholder: "Numéro SSN",
                    },
                    {
                        name: "Date of Birth",
                        type: "date",
                        fr_name: "Date de naissance",
                        required: true,
                        placeholder: "Date of Birth",
                        apiFieldName: "DOB",
                        fr_placeholder: "Date de naissance",
                    },
                ],
            },
        }
    },
    ContactTitle: [
        {
            EntityType: "Corporation",
            Titles: [
                { label: "CEO", value: "CEO" },
                { label: "COO", value: "COO" },
                { label: "CFO", value: "CFO" },
                { label: "President", value: "PRESIDENT" },
                { label: "EVP", value: "EVP" },
                { label: "SVP", value: "SVP" },
                { label: "VP", value: "VP" },
                { label: "AVP", value: "AVP" },
                { label: "Secretary", value: "SECRETARY" },
            ],
        },
        {
            EntityType: "S Corp",
            Titles: [
                { label: "CEO", value: "CEO" },
                { label: "COO", value: "COO" },
                { label: "CFO", value: "CFO" },
                { label: "President", value: "PRESIDENT" },
                { label: "EVP", value: "EVP" },
                { label: "SVP", value: "SVP" },
                { label: "VP", value: "VP" },
                { label: "AVP", value: "AVP" },
                { label: "Secretary", value: "SECRETARY" },
            ],
        },
        {
            EntityType: "Federal Government",
            Titles: [{ label: "Authorized Signatory", value: "AUTHORIZEDSIGNATORY" }],
        },
        {
            EntityType: "Limited Liability Company",
            Titles: [
                { label: "Manager", value: "MANAGER" },
                { label: "Managing Member", value: "MANAGINGMEMBER" },
            ],
        },
        {
            EntityType: "Limited Liability Partnership",
            Titles: [
                { label: "General Partner", value: "GENERALPARTNER" },
                { label: "Partner", value: "PARTNER" },
            ],
        },
        {
            EntityType: "Non Profit",
            Titles: [{ label: "Authorized Signatory", value: "AUTHORIZEDSIGNATORY" }],
        },
        {
            EntityType: "Other",
            Titles: [{ label: "Authorized Signatory", value: "AUTHORIZEDSIGNATORY" }],
        },
        {
            EntityType: "Partnership",
            Titles: [{ label: "Partner", value: "PARTNER" }],
        },
        {
            EntityType: "Sole Proprietorship",
            Titles: [{ label: "Owner", value: "OWNER" }],
        },
        {
            EntityType: "Trust or Estate",
            Titles: [{ label: "Trustee", value: "TRUSTEE" }],
        },
        {
            EntityType: "Consumer/Individual",
            Titles: [{ label: "Individual", value: "INDIVIDUAL" }],
        },
        {
            EntityType: "Municipal",
            Titles: [{ label: "Authorized Signatory", value: "AUTHORIZEDSIGNATORY" }],
        }
    ],
    regex: {
        emailRegExp: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/,
        billingEmailRegExp: /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(;[ ]+([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*$/,
        atleastOneUCharRegExp: /(?=.*?[A-Z])/,
        atleastOneLCharRegExp: /(?=.*?[a-z])/,
        atleastOneNumRegExp: /(?=.*?[0-9])/,
        atleastOneSplCharRegExp: /(?=.*?[!$%^&*])/,
        userNameRegExp: /^[A-Za-z\s]{1,50}$/,
        legalNameRegExp: /^[A-Za-z ]{1,50}$/,
        mobileNoRegExp: /^[0-9]{10}$/,
        urlRegex: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
        spaceStrtsEndsWith: /^\s+|\s+$/g,
        dealerCode: /^[a-zA-Z0-9]{6,}$/,
        allNumbers: /^[1-9]\d*$/,
        numbersAndHypens: /^[0-9-]*$/,
        allCharsExceptSpaces: / /g,
        PhoneNumber_DownPayment: /\D/g,
        PhoneNumber: /^0+|[\D]/g,
        SSN_PostalCode: /[^a-zA-Z0-9]/g,
        OwnershipPercentage: /^[0-9]+$/,
        YearsInHome_YearsEmployed: /[^0-9.]*/g,
    },
    requestStatus: {
        INITIATED: "INITIATED",
        COMPLETED: "COMPLETED",
        FAILED: "FAILED",
    },
    roleTypes: {
        VENDSREP: "VENDSREP",
        HQMANAGER: "HQMANAGER",
        BRMANAGER: "BRMANAGER",
        CUSTOMER: "CUSTOMER",
        CUSTOMER_HQMANAGER: "CUSTOMER_HQMANAGER",
        MANUFACTURER: "MANUFACTURER"
    },
    dealerRateAdjustmentTypes: {
        MARKUP: "Markup",
        BUYDOWN: "Buydown"
    },
    US_DATE_FORMAT: "MM/DD/YYYY",
    API_DATE_FORMAT: "YYYY-MM-DD",
    TOAST_TYPES: {
        INFO: "info",
        ERROR: "error",
        WARN: "warn",
    },
};
export const TaxExempt = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" },
];
export const COUNTRY_LIST = [
    { country: "USA", code: "USA" },
    { country: "Canada", code: "CAN" },
];
export const USA_STATES = [
    {
        state: "Alabama",
        code: "AL",
    },
    {
        state: "Alaska",
        code: "AK",
    },
    {
        state: "American Samoa",
        code: "AS",
    },
    {
        state: "Arizona",
        code: "AZ",
    },
    {
        state: "Arkansas",
        code: "AR",
    },
    {
        state: "California",
        code: "CA",
    },
    {
        state: "Colorado",
        code: "CO",
    },
    {
        state: "Connecticut",
        code: "CT",
    },
    {
        state: "Delaware",
        code: "DE",
    },
    {
        state: "District Of Columbia",
        code: "DC",
    },
    {
        state: "Florida",
        code: "FL",
    },
    {
        state: "Georgia",
        code: "GA",
    },
    {
        state: "Guam",
        code: "GU",
    },
    {
        state: "Hawaii",
        code: "HI",
    },
    {
        state: "Idaho",
        code: "ID",
    },
    {
        state: "Illinois",
        code: "IL",
    },
    {
        state: "Indiana",
        code: "IN",
    },
    {
        state: "Iowa",
        code: "IA",
    },
    {
        state: "Kansas",
        code: "KS",
    },
    {
        state: "Kentucky",
        code: "KY",
    },
    {
        state: "Louisiana",
        code: "LA",
    },
    {
        state: "Maine",
        code: "ME",
    },
    {
        state: "Marshall Islands",
        code: "MH",
    },
    {
        state: "Maryland",
        code: "MD",
    },
    {
        state: "Massachusetts",
        code: "MA",
    },
    {
        state: "Michigan",
        code: "MI",
    },
    {
        state: "Minnesota",
        code: "MN",
    },
    {
        state: "Mississippi",
        code: "MS",
    },
    {
        state: "Missouri",
        code: "MO",
    },
    {
        state: "Montana",
        code: "MT",
    },
    {
        state: "Nebraska",
        code: "NE",
    },
    {
        state: "Nevada",
        code: "NV",
    },
    {
        state: "New Hampshire",
        code: "NH",
    },
    {
        state: "New Jersey",
        code: "NJ",
    },
    {
        state: "New Mexico",
        code: "NM",
    },
    {
        state: "New York",
        code: "NY",
    },
    {
        state: "North Carolina",
        code: "NC",
    },
    {
        state: "North Dakota",
        code: "ND",
    },
    {
        state: "Ohio",
        code: "OH",
    },
    {
        state: "Oklahoma",
        code: "OK",
    },
    {
        state: "Oregon",
        code: "OR",
    },
    {
        state: "Palau",
        code: "PW",
    },
    {
        state: "Pennsylvania",
        code: "PA",
    },
    {
        state: "Puerto Rico",
        code: "PR",
    },
    {
        state: "Rhode Island",
        code: "RI",
    },
    {
        state: "South Carolina",
        code: "SC",
    },
    {
        state: "South Dakota",
        code: "SD",
    },
    {
        state: "Tennessee",
        code: "TN",
    },
    {
        state: "Texas",
        code: "TX",
    },
    {
        state: "Utah",
        code: "UT",
    },
    {
        state: "Vermont",
        code: "VT",
    },
    {
        state: "Virgin Islands",
        code: "VI",
    },
    {
        state: "Virginia",
        code: "VA",
    },
    {
        state: "Washington",
        code: "WA",
    },
    {
        state: "West Virginia",
        code: "WV",
    },
    {
        state: "Wisconsin",
        code: "WI",
    },
    {
        state: "Wyoming",
        code: "WY",
    },
];
export const CANADA_PROVINCES = [
    {
        state: "Alberta",
        code: "AB",
    },
    {
        state: "British Columbia",
        code: "BC",
    },
    {
        state: "Manitoba",
        code: "MB",
    },
    {
        state: "New Brunswick",
        code: "NB",
    },
    {
        state: "Newfoundland and Labrador",
        code: "NL",
    },
    {
        state: "Northwest Territories",
        code: "NT",
    },
    {
        state: "Nova Scotia",
        code: "NS",
    },
    {
        state: "Nunavut",
        code: "NU",
    },
    {
        state: "Ontario",
        code: "ON",
    },
    {
        state: "Prince Edward Island",
        code: "PE",
    },
    {
        state: "Quebec",
        code: "QC",
    },
    {
        state: "Saskatchewan",
        code: "SK",
    },
    {
        state: "Yukon Territory",
        code: "YT",
    },
];
export const COMPANY_TYPE = [
    {
        id: "1",
        Code: "C",
        Description: "Corporation",
    },
    {
        id: "16",
        Code: "SC",
        Description: "S Corp",
    },
    {
        id: "3",
        Code: "G",
        Description: "Federal Government",
    },
    {
        id: "5",
        Code: "LLC",
        Description: "Limited Liability Company",
    },
    {
        id: "6",
        Code: "LLP",
        Description: "Limited Liability Partnership",
    },
    {
        id: "7",
        Code: "N",
        Description: "Non Profit",
    },
    {
        id: "8",
        Code: "O",
        Description: "Other",
    },
    {
        id: "9",
        Code: "P",
        Description: "Partnership",
    },
    {
        id: "10",
        Code: "R",
        Description: "Sole Proprietorship",
    },
    {
        id: "13",
        Code: "TRUST",
        Description: "Trust or Estate",
    },
    {
        id: "17",
        Code: "M",
        Description: "Municipal",
    },
];
export const GUARANTOR_COMPANY_TYPE = [
    {
        id: "1",
        Code: "I",
        Description: "Consumer/Individual",
    },
    {
        id: "2",
        Code: "C",
        Description: "Corporation",
    },
    {
        id: "15",
        Code: "SC",
        Description: "S Corp",
    },
    {
        id: "3",
        Code: "G",
        Description: "Federal Government",
    },
    {
        id: "4",
        Code: "LLC",
        Description: "Limited Liability Company",
    },
    {
        id: "5",
        Code: "LLP",
        Description: "Limited Liability Partnership",
    },
    {
        id: "6",
        Code: "N",
        Description: "Non Profit",
    },
    {
        id: "7",
        Code: "O",
        Description: "Other",
    },
    {
        id: "8",
        Code: "P",
        Description: "Partnership",
    },
    {
        id: "10",
        Code: "R",
        Description: "Sole Proprietorship",
    },
    {
        id: "12",
        Code: "TRUST",
        Description: "Trust or Estate",
    },
    {
        id: "13",
        Code: "9",
        Description: "UCC AuthorizingParty",
    },
    {
        id: "14",
        Code: "2",
        Description: "UCC SecuredParty",
    },
    {
        id: "16",
        Code: "M",
        Description: "Municipal",
    },
];
export const AspireDocTypes = {
    1: { Code: "FINLSTMNTS", Description: "FinancialStatements" },
    2: { Code: "BANKSTMTS", Description: "BankStatements" },
    3: { Code: "TAXRETURNS", Description: "TaxReturns" },
    4: { Code: "DRIVERSLIC", Description: "DriversLicense" },
    5: { Code: "VOIDEDCHECKS", Description: "VoidedChecks" },
    6: { Code: "TAXEXEMPTCERT", Description: "TaxExemptionCertificates" },
    7: { Code: "OTHER", Description: "Other" },
    8: { Code: "INVOICES_SALESORDER", Description: "InvoiceSalesOrder" },
    9: { Code: "DOCPACKAGE", Description: "SignedDocuments" },
};
export const FILE_UPLOAD_DOCS = [
    { label: "Financial Statements", value: "1", key: "financialstatements", aspireDescription: AspireDocTypes[1].Description },
    { label: "Bank Statements", value: "2", key: "bankstatements", aspireDescription: AspireDocTypes[2].Description },
    { label: "Tax Returns", value: "3", key: "taxreturns", aspireDescription: AspireDocTypes[3].Description },
    { label: "Driver’s License", value: "4", key: "driverslicense", aspireDescription: AspireDocTypes[4].Description },
    { label: "Voided checks", value: "5", key: "voidedchecks", aspireDescription: AspireDocTypes[5].Description },
    { label: "Tax Exemption Certificates", value: "6", key: "taxexemptioncertificates", aspireDescription: AspireDocTypes[6].Description },
    { label: "Invoice/Sales Order", value: "8", key: "invoicesalesorder", aspireDescription: AspireDocTypes[8].Description },
    { label: "Other", value: "7", key: "other", aspireDescription: AspireDocTypes[7].Description },
];
export const DASHBOARD_FILE_UPLOAD_DOCS = [
    ...FILE_UPLOAD_DOCS,
    { label: "Signed Documents", value: "9", key: "signeddocuments", aspireDescription: AspireDocTypes[9].Description },
];
export const MONTHS = [
    { label: 12, value: 12, rate: "" },
    { label: 24, value: 24, rate: "" },
    { label: 36, value: 36, rate: "" },
    { label: 48, value: 48, rate: "" },
    { label: 60, value: 60, rate: "" },
    { label: 72, value: 72, rate: "" },
    { label: 84, value: 84, rate: "" },
    { label: 96, value: 96, rate: "" },
    { label: 108, value: 108, rate: "" },
    { label: 120, value: 120, rate: "" },
];
export var AppStatuses;
(function (AppStatuses) {
    AppStatuses["All"] = "All";
    AppStatuses["Saved Applications"] = "Draft";
    AppStatuses["Credit"] = "Credit";
    AppStatuses["Credit More Info"] = "Credit More Info";
    AppStatuses["Approved"] = "Approved";
    AppStatuses["Documents"] = "Documents";
    AppStatuses["Booked"] = "Booked";
    AppStatuses["Declined"] = "Declined";
    AppStatuses["Cancelled"] = "Cancelled";
    AppStatuses["Withdrawn"] = "Withdrawn";
    AppStatuses["Submitted"] = "Submitted";
    AppStatuses["ApprovedLoc"] = "ApprovedLoc";
    AppStatuses["ExpiredLoc"] = "ExpiredLoc";
})(AppStatuses || (AppStatuses = {}));
export const ReDocsStatus = "52 - Docs Out";
export const DocsMissingStatus = "56 - Docs Back Missing Info";
export const MoreInfoRequestedStatus = "29 - More Info Requested";
export const DocsRequestedESignatureStatus = "50 - Docs Requested ESignature";
export const DocsRequestedPdfStatus = "50 - Docs Requested PDF";
export const DocsRequestedESignatureRentalHouseStatus = "50 - Docs Requested ESignature RENTAL HOUSE";
export const DocsRequestedPdfRentalHouseStatus = "50 - Docs Requested PDF RENTAL HOUSE";
const DOCS_REQUESTED_STATUSES = [
    DocsRequestedESignatureStatus,
    DocsRequestedPdfStatus,
    DocsRequestedESignatureRentalHouseStatus,
    DocsRequestedPdfRentalHouseStatus,
];
export const isDocsRelatedStatus = (aspireStatus = '') => DOCS_REQUESTED_STATUSES.includes(aspireStatus) ||
    aspireStatus.includes(ReDocsStatus) ||
    aspireStatus === DocsMissingStatus;
export var AppSyncStatus;
(function (AppSyncStatus) {
    AppSyncStatus[AppSyncStatus["Processing"] = 1] = "Processing";
    AppSyncStatus[AppSyncStatus["Success"] = 2] = "Success";
    AppSyncStatus[AppSyncStatus["ValidationsFailed"] = 3] = "ValidationsFailed";
    AppSyncStatus[AppSyncStatus["ContactSyncFailed"] = 4] = "ContactSyncFailed";
    AppSyncStatus[AppSyncStatus["CustomerSyncFailed"] = 5] = "CustomerSyncFailed";
    AppSyncStatus[AppSyncStatus["GuarantorSyncFailed"] = 6] = "GuarantorSyncFailed";
    AppSyncStatus[AppSyncStatus["AssetSyncFailed"] = 7] = "AssetSyncFailed";
    AppSyncStatus[AppSyncStatus["ContractSyncFailed"] = 8] = "ContractSyncFailed";
    AppSyncStatus[AppSyncStatus["UploadFilesSyncFailed"] = 9] = "UploadFilesSyncFailed";
    AppSyncStatus[AppSyncStatus["MoveToAssetSyncFailed"] = 10] = "MoveToAssetSyncFailed";
    AppSyncStatus[AppSyncStatus["POFTSyncFailed"] = 11] = "POFTSyncFailed";
})(AppSyncStatus || (AppSyncStatus = {}));
export var CreateAppTypes;
(function (CreateAppTypes) {
    CreateAppTypes["NEW_CREDIT_APP"] = "new_credit_app";
    CreateAppTypes["LOC_CREDIT_APP"] = "loc_credit_app";
    CreateAppTypes["TAKEDOWN"] = "takedown_request";
    CreateAppTypes["DORF_APP"] = "dorf_app";
})(CreateAppTypes || (CreateAppTypes = {}));
export const ApplicationStatusList = [
    { label: "All", value: AppStatuses.All },
    { label: "Saved Applications", value: AppStatuses["Saved Applications"] },
    { label: "In Credit", value: AppStatuses.Credit },
    { label: "More Info Requested", value: AppStatuses["Credit More Info"] },
    { label: "Approved", value: AppStatuses.Approved },
    { label: "Approved LOC", value: AppStatuses.ApprovedLoc },
    { label: "Documents", value: AppStatuses.Documents },
    { label: "Booked", value: AppStatuses.Booked },
    { label: "Expired LOC", value: AppStatuses.ExpiredLoc },
    { label: "Declined", value: AppStatuses.Declined },
    { label: "Cancelled", value: AppStatuses.Cancelled },
];
export var DashboardSortEnum;
(function (DashboardSortEnum) {
    DashboardSortEnum["NewestFirst"] = "NewestFirst";
    DashboardSortEnum["OldestFirst"] = "OldestFirst";
    DashboardSortEnum["TxnHash"] = "TxnHash";
    DashboardSortEnum["Alpha_A_Z"] = "Alpha_A_Z";
    DashboardSortEnum["Alpha_Z_A"] = "Alpha_Z_A";
})(DashboardSortEnum || (DashboardSortEnum = {}));
export const OrderListOptions = [
    {
        label: "Newest First",
        value: DashboardSortEnum.NewestFirst,
        SortByKey: "Date",
        SortOrder: "DESC",
    },
    {
        label: "Oldest First",
        value: DashboardSortEnum.OldestFirst,
        SortByKey: "Date",
        SortOrder: "ASC",
    },
    {
        label: "Transaction#",
        value: DashboardSortEnum.TxnHash,
        SortByKey: "ContractAspireRecordId",
        SortOrder: "ASC",
    },
    {
        label: "Alphabetical (A-Z)",
        value: DashboardSortEnum.Alpha_A_Z,
        SortByKey: "Name",
        SortOrder: "ASC",
    },
    {
        label: "Alphabetical (Z-A)",
        value: DashboardSortEnum.Alpha_Z_A,
        SortByKey: "Name",
        SortOrder: "DESC",
    },
];
export var EDIT_TYPES_ENUMS;
(function (EDIT_TYPES_ENUMS) {
    EDIT_TYPES_ENUMS["CREATE"] = "CREATE";
    EDIT_TYPES_ENUMS["DRAFT"] = "DRAFT";
    EDIT_TYPES_ENUMS["IN_CREDIT_MORE_INFO"] = "IN_CREDIT_MORE_INFO";
    EDIT_TYPES_ENUMS["IN_CREDIT"] = "IN_CREDIT";
    EDIT_TYPES_ENUMS["APPROVED"] = "APPROVED";
    EDIT_TYPES_ENUMS["DOCUMENTS"] = "DOCUMENTS";
    EDIT_TYPES_ENUMS["BOOKED"] = "BOOKED";
    EDIT_TYPES_ENUMS["DECLINED"] = "DECLINED";
    EDIT_TYPES_ENUMS["CANCELLED"] = "CANCELLED";
})(EDIT_TYPES_ENUMS || (EDIT_TYPES_ENUMS = {}));
export var APPLICATION_TYPES;
(function (APPLICATION_TYPES) {
    APPLICATION_TYPES["NOR"] = "NOR";
    APPLICATION_TYPES["LOC"] = "TLC";
    APPLICATION_TYPES["SCH"] = "SCH";
    APPLICATION_TYPES["DORF"] = "DORF";
    APPLICATION_TYPES["ALL"] = "ALL";
})(APPLICATION_TYPES || (APPLICATION_TYPES = {}));
export var SIDE_MENU_ITEMS;
(function (SIDE_MENU_ITEMS) {
    SIDE_MENU_ITEMS["Dashboard"] = "Home";
    SIDE_MENU_ITEMS["Dashboard_Analytics"] = "Analytics";
    SIDE_MENU_ITEMS["QuoteTool"] = "Quote Tool";
    SIDE_MENU_ITEMS["Send_Application_Link"] = "Send Application Link";
    SIDE_MENU_ITEMS["Support"] = "Support";
    SIDE_MENU_ITEMS["RateCard"] = "Rate Card";
    SIDE_MENU_ITEMS["FAQ"] = "FAQ";
})(SIDE_MENU_ITEMS || (SIDE_MENU_ITEMS = {}));
export const SIDEMENU_OPTIONS = [
    SIDE_MENU_ITEMS.Dashboard,
    SIDE_MENU_ITEMS.Dashboard_Analytics,
    SIDE_MENU_ITEMS.QuoteTool,
    SIDE_MENU_ITEMS.Send_Application_Link,
    SIDE_MENU_ITEMS.RateCard,
    SIDE_MENU_ITEMS.FAQ,
];
export const singupAdditionalInfoFields = {
    "Business Details": [
        {
            name: "Legal Registered Name",
            type: "text",
            fr_name: "Nom légal enregistré",
            required: true,
            maxLength: 100,
            toolTipMsg: "",
            placeholder: "Legal Registered Name",
            apiFieldName: "LegalRegName",
            fr_placeholder: "Nom légal enregistré",
        },
        {
            name: "DBA Name",
            type: "text",
            fr_name: "Nom DBA",
            required: false,
            hideField: false,
            maxLength: 100,
            toolTipMsg: "”Doing Business As” or Tradename",
            placeholder: "DBA Name",
            apiFieldName: "DBAName",
            fr_toolTipMsg: "« Faire affaire sous le nom » ou nom commercial",
            fr_placeholder: "Nom DBA",
        },
        {
            name: "FED TAX ID/BN#",
            type: "text",
            fr_name: "Numéro d'identification fiscale/BN de la FED",
            required: true,
            maxLength: 15,
            toolTipMsg: "Federal Tax ID (US)/Business Number (Canada)",
            placeholder: "FED TAX ID/BN#",
            apiFieldName: "SSN",
            fr_toolTipMsg: "Numéro d'identification fiscale fédérale (États-Unis)/numéro d'entreprise (Canada)",
            fr_placeholder: "Numéro d'identification fiscale/BN de la FED",
            dropdownOptions: [],
        },
        {
            name: "Entity Type",
            type: "dropdown",
            fr_name: "Type d'entité",
            required: true,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "Entity Type",
            apiFieldName: "CompanyCode",
            fr_placeholder: "Type d'entité",
            dropdownOptions: [
                {
                    id: "1",
                    Code: "C",
                    Description: "Corporation",
                },
                {
                    id: "14",
                    Code: "SC",
                    Description: "S Corp",
                },
                {
                    id: "3",
                    Code: "G",
                    Description: "Federal Government",
                },
                {
                    id: "5",
                    Code: "LLC",
                    Description: "Limited Liability Company",
                },
                {
                    id: "6",
                    Code: "LLP",
                    Description: "Limited Liability Partnership",
                },
                {
                    id: "7",
                    Code: "N",
                    Description: "Non Profit",
                },
                {
                    id: "8",
                    Code: "O",
                    Description: "Other",
                },
                {
                    id: "9",
                    Code: "P",
                    Description: "Partnership",
                },
                {
                    id: "10",
                    Code: "R",
                    Description: "Sole Proprietorship",
                },
                {
                    id: "13",
                    Code: "TRUST",
                    Description: "Trust or Estate",
                },
                {
                    id: "17",
                    Code: "M",
                    Description: "Municipal",
                },
            ],
            dropdownOptionValueKey: "Code",
            dropdownOptionDisplayKey: "Description",
        },
        {
            name: "Country",
            type: "dropdown",
            fr_name: "Pays",
            required: true,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "Country",
            apiFieldName: "CustCountry",
            fr_placeholder: "Pays",
            dropdownOptions: [],
            dropdownOptionValueKey: "code",
            dropdownOptionDisplayKey: "country",
        },
        {
            name: "State/Province Of Incorporation",
            type: "dropdown",
            fr_name: "État/Province de constitution",
            required: true,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "State",
            apiFieldName: "CustState",
            fr_placeholder: "État/Province",
            dropdownOptions: [],
            dropdownOptionValueKey: "code",
            dropdownOptionDisplayKey: "state",
        },
        {
            name: "Date Business Incorporated",
            type: "date",
            fr_name: "Date de constitution de l'entreprise",
            required: false,
            hideField: false,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "MM/DD/YYYY",
            apiFieldName: "BusinessIncorporatedDate",
            fr_placeholder: "MM/DD/YYYY",
            dropdownOptions: [],
        },
    ],
    "Individual Details": [
        {
            name: "First Name",
            type: "text",
            fr_name: "Prénom",
            required: true,
            placeholder: "First Name",
            apiFieldName: "FirstName",
            fr_placeholder: "Prénom",
        },
        {
            name: "Middle Name",
            type: "text",
            fr_name: "Deuxième prénom",
            required: false,
            hideField: false,
            placeholder: "Middle Name",
            apiFieldName: "MiddleName",
            fr_placeholder: "Deuxième prénom",
        },
        {
            name: "Last Name",
            type: "text",
            fr_name: "Nom de famille",
            required: true,
            placeholder: "Last Name",
            apiFieldName: "LastName",
            fr_placeholder: "Nom de famille",
        },
        {
            name: "Suffix",
            type: "dropdown",
            fr_name: "Suffixe",
            required: false,
            placeholder: "Suffix",
            apiFieldName: "Suffix",
            fr_placeholder: "Suffixe",
            dropdownOptions: [
                {
                    label: "I",
                    value: "I",
                },
                {
                    label: "II",
                    value: "II",
                },
                {
                    label: "III",
                    value: "III",
                },
                {
                    label: "IV",
                    value: "IV",
                },
                {
                    label: "V",
                    value: "V",
                },
                {
                    label: "Sr.",
                    value: "Sr.",
                },
                {
                    label: "Jr.",
                    value: "Jr.",
                },
            ],
        },
        {
            name: "Business Title",
            type: "text",
            fr_name: "Titre Professionnel",
            required: false,
            hideField: false,
            placeholder: "Business Title",
            apiFieldName: "BusinessTitle",
            fr_placeholder: "Titre Professionnel",
        },
        {
            name: "Date of Birth",
            type: "date",
            fr_name: "Date de naissance",
            required: true,
            placeholder: "Date of Birth",
            apiFieldName: "DOB",
            fr_placeholder: "Date de naissance",
        },
        {
            name: "SSN#/TIN#/SIN#",
            type: "text",
            fr_name: "Numéro SSN/TIN#/SIN#",
            required: true,
            placeholder: "SSN Number",
            apiFieldName: "SSN",
            fr_placeholder: "Numéro SSN",
        },
    ],
    "Address Details": [
        {
            name: "Main Address",
            type: "text",
            fr_name: "Adresse principale",
            required: true,
            maxLength: 100,
            toolTipMsg: "",
            placeholder: "Address",
            apiFieldName: "Address",
            fr_placeholder: "Adresse principale",
        },
        {
            name: "Country",
            type: "dropdown",
            fr_name: "Pays",
            required: true,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "Country",
            apiFieldName: "Country",
            fr_placeholder: "Pays",
            dropdownOptions: [],
            dropdownOptionValueKey: "code",
            dropdownOptionDisplayKey: "country",
        },
        {
            name: "State/Province Of Incorporation",
            type: "dropdown",
            fr_name: "État/Province de constitution",
            required: true,
            maxLength: null,
            toolTipMsg: "",
            placeholder: "State",
            apiFieldName: "State",
            fr_placeholder: "État/Province",
            dropdownOptions: [],
            dropdownOptionValueKey: "code",
            dropdownOptionDisplayKey: "state",
        },
        {
            name: "City",
            type: "text",
            fr_name: "Ville",
            required: true,
            maxLength: 100,
            toolTipMsg: "",
            placeholder: "City",
            apiFieldName: "City",
            fr_placeholder: "Ville",
        },
        {
            name: "Zip/Postal Code",
            type: "text",
            fr_name: "Zip/Code postal",
            required: true,
            maxLength: 9,
            toolTipMsg: "",
            placeholder: "Zip/Postal Code",
            apiFieldName: "PostalCode",
            fr_placeholder: "Zip/Code postal",
        },
    ],
};
export default constants;
